import PageHero from "@/components/PageHero";
import { Reveal, PageShell } from "@/components/Reveal";

export default function Aktuelles() {
  return (
    <PageShell testid="aktuelles-page">
      <PageHero
        title="Aktuelles"
        subtitle="Räume für Begegnung, Bewegung und neue Erfahrungen"
        testid="aktuelles-hero"
      />

      <section data-testid="aktuelles-herzensverbindung" className="px-6 pb-16 md:px-12 md:pb-24">
        <div className="mx-auto max-w-4xl">
          <Reveal>
            <article className="rounded-[2.5rem] border border-rot/15 bg-karte p-8 md:p-14">
              <h2
                data-testid="herzensverbindung-titel"
                className="font-serif text-4xl leading-tight text-rot md:text-6xl"
              >
                Herzensverbindung
              </h2>
              <p
                data-testid="herzensverbindung-datum"
                className="mt-4 text-xs uppercase tracking-[0.3em] text-rot/80 md:text-sm"
              >
                Sonntag, 15. November 2026 · 16:00–18:00 Uhr · Eckernförde · 39 Euro
                <br />
                Sonntag, 13. Dezember 2026 · 16:00–18:00 Uhr · Eckernförde · 39 Euro
              </p>
              <div className="mt-9 space-y-5 text-base leading-loose text-anthrazit/85 md:mt-12 md:text-lg">
                <p>
                  Herzensverbindung ist ein zweistündiger Erfahrungsraum, in dem du den Alltag für
                  eine Weile hinter dir lassen kannst. Bewusste Bewegung, Atem, Körperwahrnehmung
                  und tiefe Entspannung begleiten dich aus der Anspannung zurück in deinen Körper
                  und in die Verbindung mit dir selbst.
                </p>
                <p>
                  Der Atem ist dabei dein Schlüssel. Er ist immer bei dir und schenkt dir einen
                  direkten Zugang zu deinem inneren Erleben. Wenn du beginnst, ihn bewusst
                  wahrzunehmen, darf dein Nervensystem ruhiger werden. Dein Körper kann loslassen,
                  dein Atem wieder freier fließen und in dir entsteht neuer Raum.
                </p>
                <p>
                  Du brauchst nichts zu leisten und keine Vorerfahrung mitzubringen. Du darfst dich
                  bewegen, atmen, spüren und still werden.
                </p>
                <p>So können Ruhe, Weite und neue Lebendigkeit entstehen.</p>
                <p>Dieser Raum ist für dich, wenn du</p>
                <ul className="list-disc space-y-1.5 pl-6">
                  <li>dich erschöpft oder innerlich angespannt fühlst,</li>
                  <li>auch in stillen Momenten nur schwer zur Ruhe kommst,</li>
                  <li>dich selbst wieder deutlicher spüren möchtest,</li>
                  <li>dir eine tiefe Verbindung zu deinem Körper und deinem Herzen wünschst.</li>
                </ul>
              </div>
              <figure
                data-testid="herzensverbindung-kundenstimme"
                className="mt-10 border-t border-anthrazit/10 pt-8 md:mt-12"
              >
                <blockquote className="space-y-4 font-serif text-sm italic leading-relaxed text-anthrazit/75 md:text-base">
                  <p>
                    „Gestresst und angespannt kam ich in Carmens Atemraum ‚Von Stress und Anspannung
                    zurück in deine Herzensverbindung‘.
                  </p>
                  <p>
                    Durch gezielte Atem- und Entspannungsübungen, bewusste Bewegung und wohltuende
                    Berührung kam ich wieder bei mir selbst an. In der Gruppe entstand eine fühlbare
                    und getragene Verbindung, die mich sehr berührte.
                  </p>
                  <p>
                    Am Ende spürte ich inneren Frieden und Gelassenheit. Mir wurde erneut bewusst,
                    wie elementar Selbstachtsamkeit und Selbstfürsorge für mich sind, um bei mir und
                    in meiner Kraft zu bleiben.
                  </p>
                  <p>Herzlichen Dank, Carmen, für dieses Erlebnis. Wow – mehr davon!“</p>
                </blockquote>
                <figcaption className="mt-4 text-xs uppercase tracking-[0.25em] text-anthrazit/55">
                  Yvonne
                </figcaption>
              </figure>
            </article>
          </Reveal>
        </div>
      </section>

      <section data-testid="aktuelles-trance-tanz" className="px-6 pb-16 md:px-12 md:pb-24">
        <div className="mx-auto max-w-4xl">
          <Reveal>
            <article className="rounded-[2.5rem] border border-rot/15 bg-karte p-8 md:p-14">
              <h2
                data-testid="trance-tanz-titel"
                className="font-serif text-4xl leading-tight text-rot md:text-5xl"
              >
                Trance Tanz – ein Blind Date mit dir
              </h2>
              <p
                data-testid="trance-tanz-datum"
                className="mt-4 text-xs uppercase tracking-[0.3em] text-rot/80 md:text-sm"
              >
                Samstag, 14. November 2026 · 17:00–19:30 Uhr · 39 € pro Person · Eckernförde
              </p>
              <div className="mt-9 space-y-5 text-base leading-loose text-anthrazit/85 md:mt-12 md:text-lg">
                <p>
                  Was geschieht, wenn du für eine Weile nicht gesehen wirst, nichts darstellen und
                  keinem Bild entsprechen musst?
                </p>
                <p>
                  Beim Trance Tanz bewegst du dich mit verbundenen Augen und lässt dich von Musik
                  und Rhythmus auf eine Reise mitnehmen. Der Blick geht nach innen, der Kopf darf
                  leiser werden und dein Körper übernimmt die Führung.
                </p>
                <p>
                  Es geht nicht darum, wie du tanzt oder wie es aussieht. Es geht um dich – um
                  Freiheit, Ausdruck und die Freude daran, dich ganz unmittelbar zu erleben.
                </p>
                <p>Ein Blind Date mit dir.</p>
                <p>Komm mit auf eine spannende Reise.</p>
              </div>
            </article>
          </Reveal>
        </div>
      </section>

      <section data-testid="aktuelles-loslassen" className="px-6 pb-16 md:px-12 md:pb-24">
        <div className="mx-auto max-w-4xl">
          <Reveal>
            <article className="rounded-[2.5rem] border border-rot/15 bg-karte p-8 md:p-14">
              <h2
                data-testid="loslassen-titel"
                className="font-serif text-4xl leading-tight text-rot md:text-5xl"
              >
                Loslassen, was nicht zu dir gehört
              </h2>
              <p
                data-testid="loslassen-datum"
                className="mt-4 text-xs uppercase tracking-[0.3em] text-rot/80 md:text-sm"
              >
                Sonntag, 22. November 2026 · 14:00–18:00 Uhr · Waldorfschule Eckernförde
              </p>
              <div className="mt-9 space-y-5 text-base leading-loose text-anthrazit/85 md:mt-12 md:text-lg">
                <p>
                  Ein ganzer Nachmittag für das, was du freigeben möchtest – und für das, was in
                  deinem Leben wachsen darf.
                </p>
                <p>
                  Mit Atem, Bewegung und Akupressur beziehungsweise Shiatsu erkunden wir die Themen
                  des Herbstes. Einige Akupressurpunkte erproben wir gemeinsam in Partnerübungen und
                  erleben dabei bewusst das Geben und Empfangen.
                </p>
                <p>Eine etwa 40-minütige hypnotische Reise führt dich in dein inneres Erleben.</p>
                <p>
                  Nach dem Seminar begleite ich dich noch an vier Sonntagen mit weiteren Impulsen,
                  Meditationen und Informationen rund um das Thema Loslassen.
                </p>
                <p>
                  Für Veränderung brauchst du Raum. Diesen Raum kannst nur du dir bewusst nehmen!
                </p>
                <p>Wenn du Fragen hast, schreib mir gerne eine persönliche Nachricht.</p>
                <p>Ich freue mich auf dich!</p>
                <p className="font-script text-3xl text-rot">Carmen</p>
              </div>
              <div className="mt-10 flex justify-center md:mt-12">
                <img
                  src="/images/plakat-loslassen.png"
                  alt="Seminar-Plakat: Loslassen, was nicht zu dir gehört – Sonntag, 22. November, 14 bis 18 Uhr, Waldorfschule Eckernförde"
                  data-testid="loslassen-plakat"
                  loading="lazy"
                  className="w-full max-w-xs rounded-2xl shadow-[0_24px_50px_-28px_rgba(53,51,48,0.45)] md:max-w-sm"
                />
              </div>
            </article>
          </Reveal>
        </div>
      </section>

      <section data-testid="aktuelles-intro" className="px-6 pb-16 md:px-12 md:pb-24">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <p className="text-base leading-loose text-anthrazit/85 md:text-lg">
              Neben Yoga und Shiatsu entstehen bei{" "}
              <span className="font-serif italic text-rot">Dein Körper spricht mit dir</span> immer wieder besondere
              Räume, in denen du dir selbst auf unterschiedliche Weise begegnen kannst – in der
              Natur, über den Atem, in Bewegung und in Gemeinschaft.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="aktuelles-abschluss" className="px-6 pb-28 md:px-12 md:pb-40">
        <div className="mx-auto max-w-4xl text-center">
          <Reveal>
            <p className="font-serif text-3xl italic leading-snug text-rot md:text-5xl">
              Entdecke, was gerade zu dir passt.
            </p>
          </Reveal>
        </div>
      </section>
    </PageShell>
  );
}
